import { AxiosInstance } from 'axios';

import { AttachSize } from '../models/attach.model';
import { BaseService } from './base.service';

export class AttachService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	downloadImage(opaqueid: string, size: AttachSize): Promise<any> {
		return this.http.get(`/ws/download/x/${opaqueid}/${size}`, { responseType: 'blob' });
	}

}